/* global grecaptcha */

import JustValidate from "just-validate";

export function initContactForm() {
    const form = document.querySelector('#contact-form');

    if (!form) {
        return;
    }

    const phoneInput = form.querySelector('#phone_number');
    phoneInput.addEventListener('input', function () {
        this.value = this.value.replace(/[^0-9+]/g, '');
    });

    function getSelectOptions(fieldSelector) {
        const options = [];
        const optionButtons = document.querySelectorAll(`${fieldSelector} ~ .form-select-options .form-select-opt-btn`);
        optionButtons.forEach(btn => {
            options.push(btn.textContent.trim());
        });
        return options;
    }

    const allowedSubjects = getSelectOptions('#enquiry_subject');
    const allowedMethods = getSelectOptions('#contact_method');

    const validator = new JustValidate(form, {
        errorLabelStyle: {}
    });

    const subjectApplyOption = form.dataset.subjectApplyOption;
    const enquirySubject = form.querySelector('#enquiry_subject');
    const cvPdfWrapper = form.querySelector('#cv_pdf_wrapper');
    const cvFieldStatus = {
        added: false
    }

    enquirySubject.addEventListener('change', enquirySubjectChanged.bind(
        null, subjectApplyOption, cvPdfWrapper, validator, cvFieldStatus
    ));

    function enquirySubjectChanged(subjectApplyOption, cvPdfWrapper, validator, cvFieldStatus, event) {
        if (event.target.value === subjectApplyOption) {
            cvPdfWrapper.classList.remove('smoothly-hidden');

            if (!cvFieldStatus.added) {
                validator.addField('#cv_pdf', [{
                    rule: 'files',
                    value: {
                        files: {
                            extensions: ['pdf', 'doc', 'docx'],
                            maxSize: 1024 * 1024 * 10, // 10 MB
                            types: [
                                'application/pdf',
                                'application/msword',
                                'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                            ]
                        }
                    },
                    errorMessage: 'Please upload a valid PDF or Word Doc. file of up to 10MB in size'
                }, {
                    rule: 'minFilesCount',
                    value: 1,
                    errorMessage: 'Curriculum Vitae is required'
                }], {
                    errorsContainer: '#cv_pdf_error'
                });
                cvFieldStatus.added = true;
            }
        }

        else {
            cvPdfWrapper.classList.add('smoothly-hidden');

            if (cvFieldStatus.added) {
                validator.removeField('#cv_pdf');
                cvFieldStatus.added = false;
            }
        }
    }

    const ctaLinks = document.querySelectorAll('a[data-cta-subject]');
    ctaLinks.forEach(link => {
        link.addEventListener('click', function () {
            const optIndex = this.dataset.ctaSubject;
            const optBtn = enquirySubject.parentElement.querySelector(`.form-select-opt-btn:nth-child(${optIndex})`);
            if (optBtn) {
                optBtn.click();
            }
        });
    })

    validator
        .addField('#enquiry_subject', [{
            validator: (value) => allowedSubjects.includes(value),
            errorMessage: 'Please select a valid enquiry subject'
        }], {
            errorsContainer: '#enquiry_subject_error'
        })
        .addField('#full_name', [{
            rule: 'required',
            errorMessage: 'Full name is required'
        }], {
            errorsContainer: '#full_name_error'
        })
        .addField('#email_address', [{
            rule: 'required',
            errorMessage: 'Email address is required'
        }, {
            rule: 'email',
            errorMessage: 'Please enter a valid email address'
        }], {
            errorsContainer: '#email_address_error'
        })
        .addField('#phone_number', [{
            rule: 'required',
            errorMessage: 'Phone number is required'
        }, {
            rule: 'customRegexp',
            value: /^(?:0|\+?353)(?:1\d{7}|8[35679]\d{7}|[245679]\d{6,8})$/,
            errorMessage: 'Please enter a valid Irish phone number'
        }], {
            errorsContainer: '#phone_number_error'
        })
        .addField('#contact_method', [{
            validator: (value) => allowedMethods.includes(value),
            errorMessage: 'Please select a valid preferred contact method'
        }], {
            errorsContainer: '#contact_method_error'
        })
        .addField('#enquiry_message', [{
            rule: 'required',
            errorMessage: 'Enquiry message is required'
        }], {
            errorsContainer: '#enquiry_message_error'
        });

    const mainFieldset = form.querySelector('.form-main-fieldset');

    validator.onSuccess(function (event) {
        event.preventDefault();

        const formData = new FormData(form);
        const footerError = form.querySelector('.form-footer-error');

        mainFieldset.disabled = true;
        footerError.classList.add('smoothly-hidden');

        if (grecaptcha) {
            grecaptcha.ready(function () {
                try {
                    grecaptcha.execute(form.dataset.recaptchaSiteKey, {action: formData.get('action')}).then(function (token) {
                        formData.append('recaptcha_token', token);

                        fetch(form.dataset.ajaxUrl, {method: 'POST', body: formData})
                            .then(response => response.json())
                            .then(respJson => {
                                if (respJson.success) {
                                    console.log('Success! Response:', respJson);
                                    form.classList.add('smoothly-hidden');
                                    form.nextElementSibling.classList.remove('smoothly-hidden');
                                } else {
                                    footerError.classList.remove('smoothly-hidden');
                                    mainFieldset.disabled = false;

                                    const errors = respJson.data?.errors || null;
                                    if (Array.isArray(errors) && errors.length > 0) {
                                        footerError.children[0].innerHTML = '<p>' + errors.join('</p><p>') + '</p>';
                                    } else {
                                        footerError.children[0].innerHTML = '<p>Unknown internal server error. Please try again later</p>';
                                        console.error('No errors returned from server:', respJson);
                                    }
                                }
                            })
                            .catch(error => {
                                mainFieldset.disabled = false;
                                footerError.classList.remove('smoothly-hidden');
                                footerError.children[0].innerHTML = '<p>Unknown internal server error. Please try again later</p>';
                                console.error({error});
                            });
                    });
                }
                catch (error) {
                    mainFieldset.disabled = false;
                    footerError.classList.remove('smoothly-hidden');
                    footerError.children[0].innerHTML = "<p>We couldn't verify that you're human. Please refresh the page and try again.</p>";
                    console.error({error});
                }
            });
        }
        else {
            mainFieldset.disabled = false;
            footerError.classList.remove('smoothly-hidden');
            footerError.children[0].innerHTML = "<p>We couldn't verify that you're human. Please refresh the page and try again.</p>";
        }
    });
}